<template>
  <v-dialog v-model="show" max-width="700px" persistent>
    <v-card>
      <v-card-title class="justify-center">
        <div class="text-h5 text-center">أضافة ملف Excel</div>
        <v-spacer></v-spacer>
        <v-btn icon color="primary" @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" class="align-center justify-center"> </v-col>
              <v-file-input
                label="ملف مشاريع القطاع العام"
                v-model="form.file"
                chips
                :rules="formRule"
                accept=".xlsx, .xls, .csv"
              ></v-file-input>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          elevation="2"
          width="150px"
          large
          color="primary"
          @click="AddProject"
        >
          اضافة
        </v-btn>
      </v-card-actions>
      <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
        <v-card color="primary" dark class="pa-4">
          <v-card-text>
            يرجى الانتظار...
            <v-progress-linear
              :value="progress"
              color="accent"
              class="mt-4"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";

export default {
  props: ["visible"],
  data() {
    return {
      valid: true,
      form: {
        file: null,
        is_complete: "",
      },
      loadingDialog: false,
      progress: null,
      formRule: [(v) => !!v || "حقل الادخال مطلوب"],
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    AddProject() {
      if (this.$refs.form.validate()) {
        this.loadingDialog = true;

        const formData = new FormData();
        formData.append("file", this.form.file);
        axios
          .post("auth/PublicSector/import", formData, {
            onUploadProgress: (uploadEvent) => {
              this.progress =
                Math.round((uploadEvent.loaded / uploadEvent.total) * 100) - 5;
            },
          })
          .then(() => {
            this.progress = null;
            this.AddProjectSubSector();
          })
          .catch(() => {
          this.progress = null;
          this.loadingDialog = false;
          alert("حصل خطأ في الرفع")
          });
      }
    },
    AddProjectSubSector() {
      const formData = new FormData();
      formData.append("file", this.form.file);
      axios
        .post("auth/SubSector/import", formData, {
          onUploadProgress: (uploadEvent) => {
            this.progress =
              Math.round((uploadEvent.loaded / uploadEvent.total) * 100) - 5;
          },
        })
        .then(() => {
          this.progress = null;
          this.loadingDialog = false;
        })
        .catch(() => {
          this.progress = null;
          this.loadingDialog = false;
          alert("حصل خطأ في الرفع")
        });
    },
  },
};
</script>
